import { FileStateType, FileTypeConst } from '@/common/types/Files.type';
import { FreeZonePlateType, VehiclePlate } from '@/common/types/Plate.type';
import { SelectionOptionsType } from '@/common/types/SelectionOptions.type';
import useFilterQueryParams from '@/modules/FileList/hooks/useFilterQueryParams';
import { MyFilesListQueryKey } from '@/modules/FileList/queries/myFilesList/myFilesListQuery.type';
import { useMemo } from 'react';

export type ChipDataType = {
  name: string;
  value:
    | string
    | undefined
    | SelectionOptionsType<FileTypeConst | 'all'>
    | SelectionOptionsType<'newest' | 'oldest'>
    | { label: string; value: FileStateType }
    | SelectionOptionsType<string | number>[];
  renderCondition: boolean;
  selectionOptions?: boolean;
  multiple?: boolean;
};
const useFilterChips = () => {
  const { fileListParams } = useFilterQueryParams();

  return useMemo(() => {
    const chipsData: ChipDataType[] = [
      {
        name: MyFilesListQueryKey.ORDER_ID,
        value: fileListParams?.[MyFilesListQueryKey.ORDER_ID],
        renderCondition: true,
        selectionOptions: false,
      },
      {
        name: MyFilesListQueryKey.PLATE_DESIGN,
        value: fileListParams?.[MyFilesListQueryKey.PLATE_DESIGN]?.label,
        renderCondition: true,
        selectionOptions: false,
      },
      {
        name: MyFilesListQueryKey.VEHICLE_TYPE,
        value: fileListParams?.[MyFilesListQueryKey.VEHICLE_TYPE]?.label,
        renderCondition: true,
        selectionOptions: false,
      },
      {
        name: MyFilesListQueryKey.PHONE_NUMBER,
        value: fileListParams?.[MyFilesListQueryKey.PHONE_NUMBER],
        renderCondition: true,
        selectionOptions: false,
      },
      {
        name: MyFilesListQueryKey.PLATE,
        value:
          // this chaos should get refactor as soon as possible!
          fileListParams?.[MyFilesListQueryKey.PLATE_DESIGN]?.value !==
          'country'
            ? fileListParams?.[MyFilesListQueryKey.VEHICLE_TYPE]?.enName ===
                'motorcycle' &&
              fileListParams?.[MyFilesListQueryKey.PLATE_DESIGN]?.value ===
                'free_zone'
              ? `${(fileListParams?.[MyFilesListQueryKey.PLATE]?.plate as FreeZonePlateType)?.vehicle_plate_bottom}`
              : `${(fileListParams?.[MyFilesListQueryKey.PLATE]?.plate as FreeZonePlateType)?.vehicle_plate_top}-${(fileListParams?.[MyFilesListQueryKey.PLATE]?.plate as FreeZonePlateType)?.vehicle_plate_bottom}`
            : fileListParams?.[MyFilesListQueryKey.VEHICLE_TYPE]?.enName ===
                'motorcycle'
              ? `${(fileListParams?.[MyFilesListQueryKey.PLATE]?.plate as FreeZonePlateType)?.vehicle_plate_top}-${(fileListParams?.[MyFilesListQueryKey.PLATE]?.plate as FreeZonePlateType)?.vehicle_plate_bottom}`
              : `${(fileListParams?.[MyFilesListQueryKey.PLATE]?.plate as VehiclePlate)?.iran} - ${(fileListParams?.[MyFilesListQueryKey.PLATE]?.plate as VehiclePlate)?.right}
          ${(fileListParams?.[MyFilesListQueryKey.PLATE]?.plate as VehiclePlate)?.letter?.label} ${(fileListParams?.[MyFilesListQueryKey.PLATE]?.plate as VehiclePlate)?.left} `,
        renderCondition: fileListParams?.[MyFilesListQueryKey.PLATE]
          ?.plateString
          ? true
          : false,
        selectionOptions: false,
      },

      {
        name: MyFilesListQueryKey.FILE_TYPE,
        value: fileListParams?.[MyFilesListQueryKey.FILE_TYPE],
        renderCondition:
          fileListParams?.[MyFilesListQueryKey.FILE_TYPE]?.value === 'all'
            ? false
            : true,
        selectionOptions: true,
      },
      {
        name: MyFilesListQueryKey.STATE,
        value: fileListParams?.[MyFilesListQueryKey.STATE],
        renderCondition: true,
        selectionOptions: true,
      },
      {
        name: MyFilesListQueryKey.INSURANCE,
        value: fileListParams?.[MyFilesListQueryKey.INSURANCE],
        multiple: true,
        renderCondition: true,
      },
      {
        name: MyFilesListQueryKey.FORM_DATE,
        value: `از ${fileListParams?.[MyFilesListQueryKey.FORM_DATE]}`,
        renderCondition:
          (fileListParams?.[MyFilesListQueryKey.FORM_DATE] &&
            fileListParams?.[MyFilesListQueryKey.TO_DATE]) ||
          fileListParams?.[MyFilesListQueryKey.FORM_DATE] === undefined
            ? false
            : true,
        selectionOptions: false,
      },
      {
        name: MyFilesListQueryKey.TO_DATE,
        value: `تا ${fileListParams?.[MyFilesListQueryKey.TO_DATE]}`,
        renderCondition:
          (fileListParams?.[MyFilesListQueryKey.FORM_DATE] &&
            fileListParams?.[MyFilesListQueryKey.TO_DATE]) ||
          fileListParams?.[MyFilesListQueryKey.TO_DATE] === undefined
            ? false
            : true,
        selectionOptions: false,
      },
      {
        name: MyFilesListQueryKey.SORT,
        value: fileListParams?.[MyFilesListQueryKey.SORT],
        renderCondition: true,
        selectionOptions: true,
      },
      {
        name: MyFilesListQueryKey.RANGE_DATE,
        value: `از ${fileListParams?.[MyFilesListQueryKey.FORM_DATE]} - تا ${fileListParams?.[MyFilesListQueryKey.TO_DATE]}`,
        renderCondition:
          fileListParams?.[MyFilesListQueryKey.FORM_DATE] &&
          fileListParams?.[MyFilesListQueryKey.TO_DATE]
            ? true
            : false,
        selectionOptions: false,
      },
    ];
    const filterData = chipsData.filter((item) =>
      item.multiple
        ? (item.value as SelectionOptionsType<string | number>[])?.length !== 0
          ? item.value
          : null
        : item.value
          ? item.value
          : null,
    );
    return filterData || [];
  }, [fileListParams]);
};

export default useFilterChips;
